
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_45lSMNQB6B33sMR7s2vLuRF2xBblr2GUF2K2gpr8ibQMeta } from "/work/release/fe-oj-ninja/pages/index.vue?macro=true";
import { default as indexNqiYk9sm6vaoy63czHU6vgaTwfSvrHCf_45xbN9fvFGOMMeta } from "/work/release/fe-oj-ninja/pages/oj/home/post/index.vue?macro=true";
import { default as indexrWzr8JSo8_45hK_jmz7MWPHtb4y9DYD_45fz9jUEPko24poMeta } from "/work/release/fe-oj-ninja/pages/oj/home/post/reply/index.vue?macro=true";
import { default as post9__45gRM2tWQekhiWm3Eblrrlmp2pYj0tyyqDJbSg_28sMeta } from "/work/release/fe-oj-ninja/pages/oj/home/post.vue?macro=true";
import { default as indexv1jILSvq4HLnUyCcPzLybu3QbCm5iyK1lFHuXJIVRRsMeta } from "/work/release/fe-oj-ninja/pages/oj/home/group/index.vue?macro=true";
import { default as indexhCO2ux3r2D60nL4T8E_JBiitZI2mcdeYDhied31d4_45gMeta } from "/work/release/fe-oj-ninja/pages/oj/home/group/records/index.vue?macro=true";
import { default as grouply1wmPA_45KujeVdoUjNL6foDulCOSq0irG_pgGDvqE6wMeta } from "/work/release/fe-oj-ninja/pages/oj/home/group.vue?macro=true";
import { default as indexYgJr6I_45yONcyf8WmIjMan_45q4xzzslDuHRAjxSxmFE3AMeta } from "/work/release/fe-oj-ninja/pages/oj/home/solution/index.vue?macro=true";
import { default as indexATQF_xXLobPCOu_452X8x0UPNxb8oVing8FmY_45uP4rqrsMeta } from "/work/release/fe-oj-ninja/pages/oj/home/solution/reply/index.vue?macro=true";
import { default as solution_45vtwTW6cGtdhJmQay5UEMedmJ4EIU4Hu2Wr8Zhbaz5UMeta } from "/work/release/fe-oj-ninja/pages/oj/home/solution.vue?macro=true";
import { default as index1t__45AiZ6QrtvK227XsKnmCmQY4PEZcie7vB_JjLSPLgMeta } from "/work/release/fe-oj-ninja/pages/oj/home/task/index.vue?macro=true";
import { default as indexcvwP1AHjzlbUk1gA4e0_45yVEfQzKYaJjx2iCvvJCIbcAMeta } from "/work/release/fe-oj-ninja/pages/oj/home/contest/index.vue?macro=true";
import { default as indextCdJ86sm_K_jvFS_5DQfoJ_YmGhhoy8JchJ37ydBklAMeta } from "/work/release/fe-oj-ninja/pages/oj/home/problem/index.vue?macro=true";
import { default as homexmqTo_45tPxrUpYeAJoLWLa4Y59U0xGTobmIqg1n58ZNwMeta } from "/work/release/fe-oj-ninja/pages/oj/home.vue?macro=true";
import { default as indexrh5qULF8cuMGJGb3_SSI5OatdNHr_ETmyfsHOuFap34Meta } from "/work/release/fe-oj-ninja/pages/oj/group/todo/index.vue?macro=true";
import { default as indexV8hGAl8Ui_t0slNmm9olFFLjQyLJ_453DOESJxKty_45MoAMeta } from "/work/release/fe-oj-ninja/pages/oj/group/notice/index.vue?macro=true";
import { default as index7_IlKqjzWTahp5qacOLJNSSZskS7VVFA4leLCszoMLsMeta } from "/work/release/fe-oj-ninja/pages/oj/group/contest/index.vue?macro=true";
import { default as index03tOfNRk_45uSWwBLCjq7YRBNerfm3ja_VBfdRwT4k_MEMeta } from "/work/release/fe-oj-ninja/pages/oj/group/members/index.vue?macro=true";
import { default as indexVW6q_DLkjBygFc07vPEkLF6StEmxvyk_456_ufipwDAegMeta } from "/work/release/fe-oj-ninja/pages/oj/group/problem/index.vue?macro=true";
import { default as indexSZiPBbWiYcX2sh_aGdVtZh__P9pUH9ZEub40uiTWEpEMeta } from "/work/release/fe-oj-ninja/pages/oj/group/training/index.vue?macro=true";
import { default as groupWbfOyWTQHsscg7fMla4F9Dqs9MD2NsNbpygo3k8GyCAMeta } from "/work/release/fe-oj-ninja/pages/oj/group.vue?macro=true";
import { default as indexSPk9fI7XI2xq9dITZqCsGr0fgGnmuESjBVq7X3gvM2AMeta } from "/work/release/fe-oj-ninja/pages/admin/tag/list/index.vue?macro=true";
import { default as indexdTDUqQQq3F36p9Fyz5bmZ0CjuxxFWOF_4qhD4RWn7y0Meta } from "/work/release/fe-oj-ninja/pages/admin/tag/category/index.vue?macro=true";
import { default as tagjRa5t0wk8JDofX9iL_45nE7Xx9NKj_9H_BhwL8RanP2M8Meta } from "/work/release/fe-oj-ninja/pages/admin/tag.vue?macro=true";
import { default as index7ALrdhpqilwGQQTWnPK6GOEEFvXSOYAlNB4s2EXLUxAMeta } from "/work/release/fe-oj-ninja/pages/link/index.vue?macro=true";
import { default as indexEkm7MyKBjC2BhV9b2z5E_45S4mcebWCeVK8VFNJeltglAMeta } from "/work/release/fe-oj-ninja/pages/oj/profile/index.vue?macro=true";
import { default as indexFJB4Pd8xtMiVyt_45wk9c7aIAX4UiPRScWY0GUyft_ZJIMeta } from "/work/release/fe-oj-ninja/pages/oj/profile/security/index.vue?macro=true";
import { default as indexZ9fzDKVT_4fPWrrmYw39KJod42nSzih_45zQEiDOU3QfoMeta } from "/work/release/fe-oj-ninja/pages/oj/profile/preference/index.vue?macro=true";
import { default as profile7h5al0QodRWqDSD9VzjpfZ_C74veAldkEsCJA6i8e_45QMeta } from "/work/release/fe-oj-ninja/pages/oj/profile.vue?macro=true";
import { default as indextNObVcxPkeXfBfmvMdub_28mHSc0BLhyggEag_4559kIIMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/edit/index.vue?macro=true";
import { default as indexuZdiptpuUc_ZR6Y254rLI7qARKC_fzTf3sZNy3X0ldcMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/list/index.vue?macro=true";
import { default as indexMhtuJ9irg2AAglKLQuXb91LJb7_FZ5hGVx_92zUEjjwMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/view/index.vue?macro=true";
import { default as indexRjScN8WPbXVnL2BV6O7kDHRBxZaNiEpwWFgK1_45DTVxsMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/score/index.vue?macro=true";
import { default as indextKDNymgnPQuNv80_Pf6iQWJDC9h9x_45FrwebEVSIohvMMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/create/index.vue?macro=true";
import { default as indexDVtSWd4Yxj_J6UoQ8LfxJ6_45hfj9WWaMQ50ZBTTkcVwQMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/problem/index.vue?macro=true";
import { default as indexkkcz7TRR4jlkJbJ7PdOKMcDpbhZARTNzehbWZ7hpaMEMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/submissions/index.vue?macro=true";
import { default as indexDfilXC_45dtfXAU_n346tYKx8n5XyFMRKXTCG4jLKzxjUMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/announcement/index.vue?macro=true";
import { default as indexsRmAvDpRfEmQUpY2WL2bf_450DGH2wBkOVqD7XofuiEzMMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest/announcement/create/index.vue?macro=true";
import { default as contest8onPjZupw8W7rBeSPq2WZ_45K_459qrBxCBuse2Zu1IWU6sMeta } from "/work/release/fe-oj-ninja/pages/admin/group/contest.vue?macro=true";
import { default as indexZIbZ8KWc5tc6gRLf3djBpizFrPFPTOzDx8QWuz8xqX8Meta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/list/index.vue?macro=true";
import { default as indexBdgTLNY8V1B9sg8g45DUzlriIcUDdePdgndko44CYY4Meta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/edit/oj/index.vue?macro=true";
import { default as indexmf6xOTLF72NjQgaCnlkFoK2RKYd7VrjA0fcfG5bq5XkMeta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/view/oj/index.vue?macro=true";
import { default as indexkA6zleISSsGKcE2zcBdux4fci3Up4g5Mcck7_45iBtHNoMeta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/solution/index.vue?macro=true";
import { default as indexF_45VeWnwXtqo_a_455EtjddR5V6XVBV2aQyo72rmnYeazQMeta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/create/oj/index.vue?macro=true";
import { default as indexeLOy4PgZEfjd6dRrUWEL8lfgAxgbL4q1WTN3X49HfUAMeta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/edit/objective/index.vue?macro=true";
import { default as indexjY1wvwvkqEq1iXJEv_45vXNZAYtsVJxeiyfrVV_VxrAiIMeta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/view/objective/index.vue?macro=true";
import { default as indexQ5m2skjcvkdKXMk79MmHQLv5H6Llf3_bCKL971Wu_K8Meta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/solution/create/index.vue?macro=true";
import { default as indexmqvf2fSlgxxoH1ZGFjdLhWKBjhGiqni0470m7a_45tEmsMeta } from "/work/release/fe-oj-ninja/pages/admin/group/problem/create/objective/index.vue?macro=true";
import { default as problem9h4jffj_45kB9YUdhkSfIwQNHSerEx16HoZgGe2_45qeHw8Meta } from "/work/release/fe-oj-ninja/pages/admin/group/problem.vue?macro=true";
import { default as indexOMdk6yxYVoK085DEsQKdztdHlXq_kfhHGV9NLsBW_45xcMeta } from "/work/release/fe-oj-ninja/pages/admin/group/training/edit/index.vue?macro=true";
import { default as indexxyKUoU9ZgCtmkIbKnRSJ1_453fl0fF_o8NI4HcqKjUTq0Meta } from "/work/release/fe-oj-ninja/pages/admin/group/training/list/index.vue?macro=true";
import { default as index_4cYLkFTkIhAdipCpz7vajNd_45VVqKbBA4DwZpd_45f0usMeta } from "/work/release/fe-oj-ninja/pages/admin/group/training/view/index.vue?macro=true";
import { default as indexUclha9GO9aZDFzHZTPSWutHB689UfSc8_C_Xq_45WlUEAMeta } from "/work/release/fe-oj-ninja/pages/admin/group/training/create/index.vue?macro=true";
import { default as indexRxmy5L5evEsdtBdcjAoYzPL34Jq7WDFuV0YF_iaT5NoMeta } from "/work/release/fe-oj-ninja/pages/admin/group/training/status/index.vue?macro=true";
import { default as indexcBzCStj20AoLi_qVNoRqaVVrY4QxKnVLPNSWWHtwWS4Meta } from "/work/release/fe-oj-ninja/pages/admin/group/training/problem/index.vue?macro=true";
import { default as trainingBjtB51PNINcI5rn21rWp_454_pJYqp3o9v5NSknuq9lJ4Meta } from "/work/release/fe-oj-ninja/pages/admin/group/training.vue?macro=true";
import { default as indexzeZMmQRnv4Za6uZRJPnBPQN5P0XdygSrNglvGp2Twn8Meta } from "/work/release/fe-oj-ninja/pages/admin/group/edit/index.vue?macro=true";
import { default as indexpzUy_LZ_aBZ68gA9qu_hP4FpeSzbJbk6pyMMQv_45BZFoMeta } from "/work/release/fe-oj-ninja/pages/admin/group/list/index.vue?macro=true";
import { default as index4C8cyJbxGnXIkj7kkkJxk9IDu3w8ueU_C2rFBuXMgdcMeta } from "/work/release/fe-oj-ninja/pages/admin/group/role/index.vue?macro=true";
import { default as index9EZnySI7_45QhWaGyC_Rf7kye6RP2JaImD46i9xWadgHoMeta } from "/work/release/fe-oj-ninja/pages/admin/group/view/index.vue?macro=true";
import { default as index7YMuRV_ht0WDGkUdmd8qTVc3qdvY6jEHb5MEL9tMPYwMeta } from "/work/release/fe-oj-ninja/pages/admin/group/apply/index.vue?macro=true";
import { default as indexD2kF1ygd4Fw3WA4gQsGI3_9AznuGN_b57eefdiV10M8Meta } from "/work/release/fe-oj-ninja/pages/admin/group/create/index.vue?macro=true";
import { default as indexWOaejhbEYDFgjkUFH9shazDZV13hKNHJqg2vljeF2dMMeta } from "/work/release/fe-oj-ninja/pages/admin/group/member/index.vue?macro=true";
import { default as indexXKIMfkMFZd2gBBXTr9Tc6y96EmsnHF2kC2NMvdcRSdMMeta } from "/work/release/fe-oj-ninja/pages/admin/group/announcement/index.vue?macro=true";
import { default as index_VJ6DXxRN_h2s9_45_45Lw5oKyK45nQzVaWcjq6SUwYqREcMeta } from "/work/release/fe-oj-ninja/pages/admin/group/announcement/create/index.vue?macro=true";
import { default as groupGjkj3aTDU78XQ18bDJHx9jiztuCfY_45fSRDhWnGyr3zEMeta } from "/work/release/fe-oj-ninja/pages/admin/group.vue?macro=true";
import { default as index_ZNJ9gVI5tgzdnwldStVmGcjoLX9Ozaw0iODRpQBOKAMeta } from "/work/release/fe-oj-ninja/pages/admin/index.vue?macro=true";
import { default as indexlj5IKoeLckZUpKSsKdXVdcCAQINzAyt6sthBxmY_ON0Meta } from "/work/release/fe-oj-ninja/pages/admin/contest/edit/index.vue?macro=true";
import { default as indexV6ycUgA0xZdtJUO_PwUCbK1pbmnkot7JwXs9f4W2eSYMeta } from "/work/release/fe-oj-ninja/pages/admin/contest/list/index.vue?macro=true";
import { default as indexbeytsaBiKNp6PRSNgi2U0LIOmha4ljRer_PlEKdSYTYMeta } from "/work/release/fe-oj-ninja/pages/admin/contest/view/index.vue?macro=true";
import { default as indexVptgxYqR_00dg6rqUd4BiASsLIp2z1aWVTw_457YG61CsMeta } from "/work/release/fe-oj-ninja/pages/admin/contest/score/index.vue?macro=true";
import { default as indexP9UbNYiTWKkmF0H3ZZ_45psQQNs7EByHBd90FS_45hxBzrYMeta } from "/work/release/fe-oj-ninja/pages/admin/contest/create/index.vue?macro=true";
import { default as indexIMb1WTsxqdtAAxoyaH1bMskP9oZWvZDT4F6aAX_45TsOsMeta } from "/work/release/fe-oj-ninja/pages/admin/contest/problem/index.vue?macro=true";
import { default as index7TjAzaR_7CFclx85YUl7u8cNayaVQUAyD7_45z38hku2UMeta } from "/work/release/fe-oj-ninja/pages/admin/contest/submissions/index.vue?macro=true";
import { default as indexUPixVlElQPpUTSpR2y8yCWf8Cs_45YQpuV0Yy_45jbPJ9_450Meta } from "/work/release/fe-oj-ninja/pages/admin/contest/announcement/index.vue?macro=true";
import { default as index_45Ie_BLYeZ6FbuQGbddzZxcMeeZD2XzmkkwxTU1mFuQ0Meta } from "/work/release/fe-oj-ninja/pages/admin/contest/announcement/create/index.vue?macro=true";
import { default as contestwYf_45NYjnbh_45QDdBIDSJrqF4ZFw_45wpgNTiZ0mVpx26ckMeta } from "/work/release/fe-oj-ninja/pages/admin/contest.vue?macro=true";
import { default as indexck70JxAZffwdn6SNz5oXn9BTR6T2CaclIn0ahnQgC0QMeta } from "/work/release/fe-oj-ninja/pages/admin/problem/list/index.vue?macro=true";
import { default as indextPJeqC_atUwUZ41fMZPEUvGRbbNV47Kynh2EzQan7f8Meta } from "/work/release/fe-oj-ninja/pages/admin/problem/edit/oj/index.vue?macro=true";
import { default as indexlsfNLuUJWzbgrpnZOHAql5XVXWr5jz6leZHHPytN1r4Meta } from "/work/release/fe-oj-ninja/pages/admin/problem/view/oj/index.vue?macro=true";
import { default as indexTpW008Ry_7uczmgFQkqdLmbtsc4NnaWci7n4VHEd6q8Meta } from "/work/release/fe-oj-ninja/pages/admin/problem/solution/index.vue?macro=true";
import { default as indexTKVNQ69C_9uhHgxfkoLNYo4u_e3eM3zhzfT2hmi4Vo0Meta } from "/work/release/fe-oj-ninja/pages/admin/problem/create/oj/index.vue?macro=true";
import { default as indexLqkJbNRLyzr146gvLOpA8aNa6S_45gE3Ftkk4GrsdPRCAMeta } from "/work/release/fe-oj-ninja/pages/admin/problem/edit/objective/index.vue?macro=true";
import { default as indexQLoyjWUuvPQog4ug9fUqtOGwrrBN9rw1wPubG9TdoC4Meta } from "/work/release/fe-oj-ninja/pages/admin/problem/view/objective/index.vue?macro=true";
import { default as index_45OBQJkYSHVs05lGGz_45uFiZNPz6yERrBaaeB46sRalsQMeta } from "/work/release/fe-oj-ninja/pages/admin/problem/solution/create/index.vue?macro=true";
import { default as indexF1GPSHVWh2sM97no_Pe9Xb680RNXxfhFJUNeH6qQbe0Meta } from "/work/release/fe-oj-ninja/pages/admin/problem/create/objective/index.vue?macro=true";
import { default as problemZtWLAina7_45C1jMUQ4wlxHaglV6aelxlV8suFun8OvZYMeta } from "/work/release/fe-oj-ninja/pages/admin/problem.vue?macro=true";
import { default as indexC4A0WcPD9AAsSHzy5LkQNpen0vhe_yL7zSDDNh7KgnEMeta } from "/work/release/fe-oj-ninja/pages/oj/task/index.vue?macro=true";
import { default as indexJSWBhdlLlpdBK4Ve1tbT88wYGnoA_45OIT61o45y8ZoiUMeta } from "/work/release/fe-oj-ninja/pages/admin/training/edit/index.vue?macro=true";
import { default as indexBxFFULHs5zgAs5_45qcc6s_45aVGNH0kQHPRJqTDvuToiHYMeta } from "/work/release/fe-oj-ninja/pages/admin/training/list/index.vue?macro=true";
import { default as indexCebpB3YZ6lOebrzVnorG89HHitKlzvIgDjsAyvAOFxMMeta } from "/work/release/fe-oj-ninja/pages/admin/training/view/index.vue?macro=true";
import { default as indexMdilp8FjTErLUPE75IWjQg_c2u1wupZEWgGQdrjRPhsMeta } from "/work/release/fe-oj-ninja/pages/admin/training/create/index.vue?macro=true";
import { default as indexwnopxNnM8HyL_gcTg8PWTsTT2tkUsj4uUZe4SBEkO6kMeta } from "/work/release/fe-oj-ninja/pages/admin/training/status/index.vue?macro=true";
import { default as indexsApNAJJgcyXrmWwJOAvdYGm43SqyIhCoE89YYNobXHIMeta } from "/work/release/fe-oj-ninja/pages/admin/training/problem/index.vue?macro=true";
import { default as trainingAZCYlT_y0WtV6Gtp3N6YTv0X8Xbg_KTy__heK1ZqovsMeta } from "/work/release/fe-oj-ninja/pages/admin/training.vue?macro=true";
import { default as index9Rk_45YSL_nTFFZ4MY0S_45103RhZaoOOWits0wg8IZoXS8Meta } from "/work/release/fe-oj-ninja/pages/oj/guide/index.vue?macro=true";
import { default as indexRYbWD5EmnnlxKelqJ_452upOiZsTytDk4Q6EGtq3pmuSQMeta } from "/work/release/fe-oj-ninja/pages/admin/community/post/index.vue?macro=true";
import { default as index9wEfQAx49jyJPU7P2QZfZdy8Mqyoi0QJ_xv_456dJLdsIMeta } from "/work/release/fe-oj-ninja/pages/admin/community/solution/index.vue?macro=true";
import { default as indexrhOav_45xTpN5a042HxraE4f0Arn7STlC6bzgve7EC76IMeta } from "/work/release/fe-oj-ninja/pages/admin/community/post/comment/index.vue?macro=true";
import { default as indexxia4GDYL9FmwOEFuFSy0nVNQmpkLTQp_7__45dGAjox68Meta } from "/work/release/fe-oj-ninja/pages/admin/community/problem/comment/index.vue?macro=true";
import { default as index9EutJxo_454d9qD09uZ3QSBo8dFqnfiAEaNeXo9Bvlp8sMeta } from "/work/release/fe-oj-ninja/pages/admin/community/solution/comment/index.vue?macro=true";
import { default as communityLsaD3caELouAM0FOXNfuJfmz_454fL1obwFA0Q887VKtwMeta } from "/work/release/fe-oj-ninja/pages/admin/community.vue?macro=true";
import { default as indexFVxUUAqiRvNGTqdBoHu8vqgWt8zr5cPV8H7VSutlvKsMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse/edit/index.vue?macro=true";
import { default as indexYcvZw1TIvEh0WebHDvXzbMCgma_10z_45f8dCsIrfWHmAMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse/list/index.vue?macro=true";
import { default as indexIirtLAEgd_45d_7UjOtHXv4dz6JEAUnVqxvMYFLdopO7wMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse/view/index.vue?macro=true";
import { default as indexuLTVW7AdzZS_hV8v7kbTdNo3glX88GdwymnzNP8i0CsMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse/create/index.vue?macro=true";
import { default as index3zlb4IQcjZQ48N2vJ6H441mn0wIiK7x214okF_45zILzYMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse/import/index.vue?macro=true";
import { default as indexCFzhxeLK6KSX1TxNwOQ_45Cpi_45gCT1ZeVOBC2Ajg96eREMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse/problem/index.vue?macro=true";
import { default as warehousedG1dMMHuehEEpyUooS3ykYKRWPRMZ4kN4MjXagUWaakMeta } from "/work/release/fe-oj-ninja/pages/admin/warehouse.vue?macro=true";
import { default as indexuWw4_45yJR0tDi02qEU32SV6nj_45_uE6Z_HYneEZJMXWPwMeta } from "/work/release/fe-oj-ninja/pages/oj/notice/index.vue?macro=true";
import { default as index0_45iRiitlygsCobDrn0KBlwkQPBlSeHE0Rmts_45ffSQCUMeta } from "/work/release/fe-oj-ninja/pages/admin/user/index.vue?macro=true";
import { default as indexsRbXHGvMMIqu_93iANyiVo4QZxquSlK0N5KaEJEupA8Meta } from "/work/release/fe-oj-ninja/pages/discuss/category/general/index.vue?macro=true";
import { default as indexLjg3IGRcT79v5_45jkFjnBoSPElX3W8jlFflPu0ZWUF1wMeta } from "/work/release/fe-oj-ninja/pages/discuss/category/academic/index.vue?macro=true";
import { default as category9tTnrmVEqMW244AVWtQLRpAy01enELHIMEdDyUyTL_0Meta } from "/work/release/fe-oj-ninja/pages/discuss/category.vue?macro=true";
import { default as indexhfMHKxOUzOvUnG90gUyM7awPLTh0oVt6YoK8qYeuHhAMeta } from "/work/release/fe-oj-ninja/pages/oj/article/index.vue?macro=true";
import { default as indexc7G6DZlx422nqsWIeS5n5M_45Q6BIJPWhAiAG7rBfyUzkMeta } from "/work/release/fe-oj-ninja/pages/oj/contest/index.vue?macro=true";
import { default as index65pVChW0Hq9W7Vt3dbsNVzkRwGv0WS58Cnugzt2ypNkMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/index.vue?macro=true";
import { default as indexwgu9nGRRVoRwx3UF35faUFee7uWX5GAATqGuUXqer_wMeta } from "/work/release/fe-oj-ninja/pages/oj/ranking/index.vue?macro=true";
import { default as indexwxIMIWye8WFBsgLz8LKvKUL0ws0PCj554UwlzvX0_SAMeta } from "/work/release/fe-oj-ninja/pages/admin/indexconfig/banner/index.vue?macro=true";
import { default as indexhyVu4Sho7yzIBlHSoXmFukHf1Ts3yi9lIBieSlvL8s4Meta } from "/work/release/fe-oj-ninja/pages/admin/indexconfig/article/index.vue?macro=true";
import { default as indexsvn__zzfA4_jUlY_45K1jUiLpXw3WkuGXDGaYMWzYJSNEMeta } from "/work/release/fe-oj-ninja/pages/admin/indexconfig/contest/index.vue?macro=true";
import { default as index7R1NPBSzKXGyAW26TJlFkf8_45grsVfPnhVUP5bWcdcvoMeta } from "/work/release/fe-oj-ninja/pages/admin/indexconfig/banner/create/index.vue?macro=true";
import { default as indexLELOlpi2UCGUuXMpru6HS8DuFBtbiSTNLdGY4eyQzdUMeta } from "/work/release/fe-oj-ninja/pages/admin/indexconfig/article/create/index.vue?macro=true";
import { default as indexconfig7_45MBS0qaAAIcTtganMRMuhKwCJ3ZYCcJ469mcAEK7hYMeta } from "/work/release/fe-oj-ninja/pages/admin/indexconfig.vue?macro=true";
import { default as indexCTMrcfwN__nBZjNU3e_45di76aIjAXUWQJSJfI1STl6JUMeta } from "/work/release/fe-oj-ninja/pages/oj/backpack/index.vue?macro=true";
import { default as indexP5ZuqQX8W9J6RdJnWeVbREa0JF2rVNhn0btKTv4ZzdIMeta } from "/work/release/fe-oj-ninja/pages/oj/contest/detail/index.vue?macro=true";
import { default as indexZ09mMIt0A6pU1DGQnKsEU01OZFayNTl5BX2WZqs_YQQMeta } from "/work/release/fe-oj-ninja/pages/oj/contest/detail/score/index.vue?macro=true";
import { default as indexrtSZFHbvN0_YJ1532qcE5lRmggdlZVIiqXC5oJs6GUUMeta } from "/work/release/fe-oj-ninja/pages/oj/contest/detail/notice/index.vue?macro=true";
import { default as index6x3SETeFtL_45NIvhekpRZsJgq3EB3BvB93FRZyvBC5FIMeta } from "/work/release/fe-oj-ninja/pages/oj/contest/detail/problem/index.vue?macro=true";
import { default as detailoyYV5blsf7EuTDdggDj3BkKKFCDTXEIVntks9pxBdW0Meta } from "/work/release/fe-oj-ninja/pages/oj/contest/detail.vue?macro=true";
import { default as indexrDqm0ICd2eOy_6qvSRcfcxYrk5qKilHusgpGue5ha_wMeta } from "/work/release/fe-oj-ninja/pages/oj/training/index.vue?macro=true";
import { default as indexBjtG_45Mjk1UgLnyUQ6sL195B8Y502uC_45NdAkzBpo9MmAMeta } from "/work/release/fe-oj-ninja/pages/oj/training/detail/index.vue?macro=true";
import { default as indexe_45t_45KZ1_rRP6F74aCkbtxVjF3sRHsbU4lpJquVAdg6oMeta } from "/work/release/fe-oj-ninja/pages/oj/training/detail/problem/index.vue?macro=true";
import { default as detailzZNsKg2khTBhOJ453A6Hu88vwC0RILTvFYhWnAvtTpcMeta } from "/work/release/fe-oj-ninja/pages/oj/training/detail.vue?macro=true";
import { default as indexiRgkGHvaqE6UbP8uRQjvZBE0oOQOD0ZrJggx4BzDHFoMeta } from "/work/release/fe-oj-ninja/pages/callback/code/index.vue?macro=true";
import { default as indexcQcOFcS8H1VDvta6FJ07F8fpcVwsP_45DtKKxeivp0LcYMeta } from "/work/release/fe-oj-ninja/pages/callback/group/index.vue?macro=true";
import { default as indexAnm0mIIbPZSE3k_45ljXlQ76UIttU17EHnEk0cBS2RyCUMeta } from "/work/release/fe-oj-ninja/pages/callback/feishu/index.vue?macro=true";
import { default as index1GyQhMB5bSTyX5IePtGT9BFjRcY5ULPu0l7MPCXMtHgMeta } from "/work/release/fe-oj-ninja/pages/callback/wechat/index.vue?macro=true";
import { default as indexa8Lawgz1WiRtGlfjKcXZ_yeW74D6EEgjRf3xGlI5FscMeta } from "/work/release/fe-oj-ninja/pages/oj/announcement/index.vue?macro=true";
import { default as indexXQa0EAT7x6aUfa8tSM0DNwVs1XZ6PJ6lwldJXVTaldEMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/reward/badge/index.vue?macro=true";
import { default as indexylVO5zT53X_AHUFG_tvoZTiD2Mt20g1VJTbu0GqWGZ8Meta } from "/work/release/fe-oj-ninja/pages/admin/incentive/reward/avatarframe/index.vue?macro=true";
import { default as indexobCwL1uMyAGIrrHUwcTVXmdmA6Smm6nKAP9mCRw5L_45oMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/reward/cursortrails/index.vue?macro=true";
import { default as indextPy2wuMePFePUIv3vVcd3WCkabamNdDCPRmxMHD4QvEMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/reward/homebackground/index.vue?macro=true";
import { default as indexIz5iDvoe3W6Nt3DHCnedjfkyV9e62Fjcez8y8Gx1sB8Meta } from "/work/release/fe-oj-ninja/pages/admin/incentive/reward/gradedecoration/index.vue?macro=true";
import { default as reward5SZjCYEjCV6GoIKxQRR0_45fYZUqcb650C2XPq3HfsLdwMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/reward.vue?macro=true";
import { default as index_45Ea_45lE9ly3Fg7wt9PORvb35O4_45mt1dd13fJQuhW695gMeta } from "/work/release/fe-oj-ninja/pages/admin/submission/index.vue?macro=true";
import { default as indexJ8hdhXjxnVD_Q5c64R86KDMmakG6LQmdHZf4lZNQfUEMeta } from "/work/release/fe-oj-ninja/pages/oj/entrance-exam/index.vue?macro=true";
import { default as indexCz_oU3kI0RmsLqPQ3df0qfstZqgH_bTyWqzBz5V7OKIMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/edit/index.vue?macro=true";
import { default as indexoGDmQxHNA0bI_45VaZh2ZasH0P5sfp3FuBCqAo2QMum98Meta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/view/index.vue?macro=true";
import { default as indexkQcCN6Cef0de7kgbi_5BQZa9ZLBCTvcKS6m3FyRsQ60Meta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/goods/index.vue?macro=true";
import { default as indexyzTNbgmhKFzVRPkORP6QEC_2yx77j_N3_45svYItNY4qEMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/medal/index.vue?macro=true";
import { default as index8evFifEQ3jPqnQCbV6XKp_45RA9cE23A_X_1w8dvXE3RMMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/create/index.vue?macro=true";
import { default as indexbzVgWvv0epktwCiPM_459ACTNikmS21D4kIBDcRWIob5oMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/manual/index.vue?macro=true";
import { default as index0kmiqxKIehNipOKlEJFO9wnNjkc2nVmUGnBKANsBdEUMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/normal/index.vue?macro=true";
import { default as indexj_450ZXRatbEq66jp42ku3O_45_KcyJuuTnc9NRYJsBtNaIMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission/random/index.vue?macro=true";
import { default as mission3z_P3vJoZ_45Zd0URpnx4DyAmxw9_R8nihZteZoVPEGcsMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/mission.vue?macro=true";
import { default as index6gapf0ZAc170u12BSZn8YBBDl9mM7tmhrqQ3cy7VVzwMeta } from "/work/release/fe-oj-ninja/pages/discuss/post/edit/index.vue?macro=true";
import { default as indexB4U6RyuG6nmU13ae5kX3x1vrBCHYWwWjwG1aRKGgHMIMeta } from "/work/release/fe-oj-ninja/pages/oj/article/detail/index.vue?macro=true";
import { default as indexLgPhsEIw3po5AlcN5injinQs9flpCWNc7SJrqDujMskMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/detail/index.vue?macro=true";
import { default as indexwwPpniRCEb_BuWEHNJlzM1SiV9xNkuSMx8_45_45WZ8XcckMeta } from "/work/release/fe-oj-ninja/pages/admin/clouddesktop/index.vue?macro=true";
import { default as indextHKzLN1VmJLQi1WTQdYIV7n_45xMRd0_45Wf41FlAbX__45kUMeta } from "/work/release/fe-oj-ninja/pages/oj/activity/zongzi/index.vue?macro=true";
import { default as index8V9WGVHj90r_450kGHH9uqz7s2_451PleoyxwqtE6dT2a_MMeta } from "/work/release/fe-oj-ninja/pages/discuss/post/create/index.vue?macro=true";
import { default as indexOODfGCB3YIOVDu7OJrRvMZ0sfrx1RgREHzBx3GPf4OcMeta } from "/work/release/fe-oj-ninja/pages/discuss/post/detail/index.vue?macro=true";
import { default as indexudKOeRMY2IcZ9VVKLOPBzGsDKC9r2328UL34IAgYC_45gMeta } from "/work/release/fe-oj-ninja/pages/oj/activity/lantern/index.vue?macro=true";
import { default as indexTg8l20YCXo1uJaCJ86LFqSPv1TMKL4qs0fVWZX9CnWUMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/solution/index.vue?macro=true";
import { default as indexlb85F_45rGqLPseTzc0ITFlcxqcUgDheJgDEIKp7JN8gwMeta } from "/work/release/fe-oj-ninja/pages/admin/incentive/level/index.vue?macro=true";
import { default as indexQ0Orz4xDAh90x7RoSlB28uy_45yGAM_TTHdiAWiP173vgMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/submit/list/index.vue?macro=true";
import { default as index071s0gZ0k0TC_4564HDaJLYlMggCI_KOQXuOG_7FFjTpIMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/solution/edit/index.vue?macro=true";
import { default as index2eKtw7iU5_45LTd6l9K3VwF7wHlRsjQabYC75Js6My68kMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/submit/result/index.vue?macro=true";
import { default as indexA5j7BkP0eAo_45HcmZPiHoxNM3qv7stduw6wLlO8xxMPYMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/solution/create/index.vue?macro=true";
import { default as indexrSqjS1jbtBXFEIMFW5XiivWBfYFCtjkrwKslEQUOvREMeta } from "/work/release/fe-oj-ninja/pages/oj/problem/solution/detail/index.vue?macro=true";
import { default as component_45stubDMgF2QhSnKdc6GIkjVfhMgbG5hzZAWM_45yH1BKqK2dlUMeta } from "/work/release/fe-oj-ninja/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@20.17.57_db0@0.3.2_eslint@_p46ffyktbbexzolaknm7qzttwe/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubDMgF2QhSnKdc6GIkjVfhMgbG5hzZAWM_45yH1BKqK2dlU } from "/work/release/fe-oj-ninja/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@20.17.57_db0@0.3.2_eslint@_p46ffyktbbexzolaknm7qzttwe/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_45lSMNQB6B33sMR7s2vLuRF2xBblr2GUF2K2gpr8ibQMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/index.vue")
  },
  {
    name: "oj_home",
    path: "/oj/home",
    meta: homexmqTo_45tPxrUpYeAJoLWLa4Y59U0xGTobmIqg1n58ZNwMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home.vue"),
    children: [
  {
    name: post9__45gRM2tWQekhiWm3Eblrrlmp2pYj0tyyqDJbSg_28sMeta?.name,
    path: "post",
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/post.vue"),
    children: [
  {
    name: "oj_home_post",
    path: "",
    meta: indexNqiYk9sm6vaoy63czHU6vgaTwfSvrHCf_45xbN9fvFGOMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/post/index.vue")
  },
  {
    name: "oj_home_post_reply",
    path: "reply",
    meta: indexrWzr8JSo8_45hK_jmz7MWPHtb4y9DYD_45fz9jUEPko24poMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/post/reply/index.vue")
  }
]
  },
  {
    name: grouply1wmPA_45KujeVdoUjNL6foDulCOSq0irG_pgGDvqE6wMeta?.name,
    path: "group",
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/group.vue"),
    children: [
  {
    name: "oj_home_group",
    path: "",
    meta: indexv1jILSvq4HLnUyCcPzLybu3QbCm5iyK1lFHuXJIVRRsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/group/index.vue")
  },
  {
    name: "oj_home_group_records",
    path: "records",
    meta: indexhCO2ux3r2D60nL4T8E_JBiitZI2mcdeYDhied31d4_45gMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/group/records/index.vue")
  }
]
  },
  {
    name: solution_45vtwTW6cGtdhJmQay5UEMedmJ4EIU4Hu2Wr8Zhbaz5UMeta?.name,
    path: "solution",
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/solution.vue"),
    children: [
  {
    name: "oj_home_solution",
    path: "",
    meta: indexYgJr6I_45yONcyf8WmIjMan_45q4xzzslDuHRAjxSxmFE3AMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/solution/index.vue")
  },
  {
    name: "oj_home_solution_reply",
    path: "reply",
    meta: indexATQF_xXLobPCOu_452X8x0UPNxb8oVing8FmY_45uP4rqrsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/solution/reply/index.vue")
  }
]
  },
  {
    name: "oj_home_task",
    path: "task",
    meta: index1t__45AiZ6QrtvK227XsKnmCmQY4PEZcie7vB_JjLSPLgMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/task/index.vue")
  },
  {
    name: "oj_home_contest",
    path: "contest",
    meta: indexcvwP1AHjzlbUk1gA4e0_45yVEfQzKYaJjx2iCvvJCIbcAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/contest/index.vue")
  },
  {
    name: "oj_home_problem",
    path: "problem",
    meta: indextCdJ86sm_K_jvFS_5DQfoJ_YmGhhoy8JchJ37ydBklAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/home/problem/index.vue")
  }
]
  },
  {
    name: "oj-group",
    path: "/oj/group",
    meta: groupWbfOyWTQHsscg7fMla4F9Dqs9MD2NsNbpygo3k8GyCAMeta || {},
    redirect: {"name":"oj_group_problem"},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group.vue"),
    children: [
  {
    name: "oj_group_todo",
    path: "todo",
    meta: indexrh5qULF8cuMGJGb3_SSI5OatdNHr_ETmyfsHOuFap34Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group/todo/index.vue")
  },
  {
    name: "oj_group_notice",
    path: "notice",
    meta: indexV8hGAl8Ui_t0slNmm9olFFLjQyLJ_453DOESJxKty_45MoAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group/notice/index.vue")
  },
  {
    name: "oj_group_contest",
    path: "contest",
    meta: index7_IlKqjzWTahp5qacOLJNSSZskS7VVFA4leLCszoMLsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group/contest/index.vue")
  },
  {
    name: "oj_group_members",
    path: "members",
    meta: index03tOfNRk_45uSWwBLCjq7YRBNerfm3ja_VBfdRwT4k_MEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group/members/index.vue")
  },
  {
    name: "oj_group_problem",
    path: "problem",
    meta: indexVW6q_DLkjBygFc07vPEkLF6StEmxvyk_456_ufipwDAegMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group/problem/index.vue")
  },
  {
    name: "oj_group_training",
    path: "training",
    meta: indexSZiPBbWiYcX2sh_aGdVtZh__P9pUH9ZEub40uiTWEpEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/group/training/index.vue")
  }
]
  },
  {
    name: "admin-tag",
    path: "/admin/tag",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/tag.vue"),
    children: [
  {
    name: "admin_tag_list",
    path: "list",
    meta: indexSPk9fI7XI2xq9dITZqCsGr0fgGnmuESjBVq7X3gvM2AMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/tag/list/index.vue")
  },
  {
    name: "admin_tag_category",
    path: "category",
    meta: indexdTDUqQQq3F36p9Fyz5bmZ0CjuxxFWOF_4qhD4RWn7y0Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/tag/category/index.vue")
  }
]
  },
  {
    name: "link",
    path: "/link",
    meta: index7ALrdhpqilwGQQTWnPK6GOEEFvXSOYAlNB4s2EXLUxAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/link/index.vue")
  },
  {
    name: profile7h5al0QodRWqDSD9VzjpfZ_C74veAldkEsCJA6i8e_45QMeta?.name,
    path: "/oj/profile",
    component: () => import("/work/release/fe-oj-ninja/pages/oj/profile.vue"),
    children: [
  {
    name: "oj_profile",
    path: "",
    meta: indexEkm7MyKBjC2BhV9b2z5E_45S4mcebWCeVK8VFNJeltglAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/profile/index.vue")
  },
  {
    name: "oj_profile_security",
    path: "security",
    meta: indexFJB4Pd8xtMiVyt_45wk9c7aIAX4UiPRScWY0GUyft_ZJIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/profile/security/index.vue")
  },
  {
    name: "oj_profile_preference",
    path: "preference",
    meta: indexZ9fzDKVT_4fPWrrmYw39KJod42nSzih_45zQEiDOU3QfoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/profile/preference/index.vue")
  }
]
  },
  {
    name: "admin-group",
    path: "/admin/group",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group.vue"),
    children: [
  {
    name: "admin-group-contest",
    path: "contest",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest.vue"),
    children: [
  {
    name: "admin_group_contest_edit",
    path: "edit",
    meta: indextNObVcxPkeXfBfmvMdub_28mHSc0BLhyggEag_4559kIIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/edit/index.vue")
  },
  {
    name: "admin_group_contest_list",
    path: "list",
    meta: indexuZdiptpuUc_ZR6Y254rLI7qARKC_fzTf3sZNy3X0ldcMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/list/index.vue")
  },
  {
    name: "admin_group_contest_view",
    path: "view",
    meta: indexMhtuJ9irg2AAglKLQuXb91LJb7_FZ5hGVx_92zUEjjwMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/view/index.vue")
  },
  {
    name: "admin_group_contest_score",
    path: "score",
    meta: indexRjScN8WPbXVnL2BV6O7kDHRBxZaNiEpwWFgK1_45DTVxsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/score/index.vue")
  },
  {
    name: "admin_group_contest_create",
    path: "create",
    meta: indextKDNymgnPQuNv80_Pf6iQWJDC9h9x_45FrwebEVSIohvMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/create/index.vue")
  },
  {
    name: "admin_group_contest_problem",
    path: "problem",
    meta: indexDVtSWd4Yxj_J6UoQ8LfxJ6_45hfj9WWaMQ50ZBTTkcVwQMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/problem/index.vue")
  },
  {
    name: "admin_group_contest_submissions",
    path: "submissions",
    meta: indexkkcz7TRR4jlkJbJ7PdOKMcDpbhZARTNzehbWZ7hpaMEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/submissions/index.vue")
  },
  {
    name: "admin_group_contest_announcement",
    path: "announcement",
    meta: indexDfilXC_45dtfXAU_n346tYKx8n5XyFMRKXTCG4jLKzxjUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/announcement/index.vue")
  },
  {
    name: "admin_group_contest_announcement_create",
    path: "announcement/create",
    meta: indexsRmAvDpRfEmQUpY2WL2bf_450DGH2wBkOVqD7XofuiEzMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/contest/announcement/create/index.vue")
  }
]
  },
  {
    name: "admin-group-problem",
    path: "problem",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem.vue"),
    children: [
  {
    name: "admin_group_problem_list",
    path: "list",
    meta: indexZIbZ8KWc5tc6gRLf3djBpizFrPFPTOzDx8QWuz8xqX8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/list/index.vue")
  },
  {
    name: "admin_group_problem_edit_oj",
    path: "edit/oj",
    meta: indexBdgTLNY8V1B9sg8g45DUzlriIcUDdePdgndko44CYY4Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/edit/oj/index.vue")
  },
  {
    name: "admin_group_problem_view_oj",
    path: "view/oj",
    meta: indexmf6xOTLF72NjQgaCnlkFoK2RKYd7VrjA0fcfG5bq5XkMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/view/oj/index.vue")
  },
  {
    name: "admin_group_problem_solution",
    path: "solution",
    meta: indexkA6zleISSsGKcE2zcBdux4fci3Up4g5Mcck7_45iBtHNoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/solution/index.vue")
  },
  {
    name: "admin_group_problem_create_oj",
    path: "create/oj",
    meta: indexF_45VeWnwXtqo_a_455EtjddR5V6XVBV2aQyo72rmnYeazQMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/create/oj/index.vue")
  },
  {
    name: "admin_group_problem_edit_objective",
    path: "edit/objective",
    meta: indexeLOy4PgZEfjd6dRrUWEL8lfgAxgbL4q1WTN3X49HfUAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/edit/objective/index.vue")
  },
  {
    name: "admin_group_problem_view_objective",
    path: "view/objective",
    meta: indexjY1wvwvkqEq1iXJEv_45vXNZAYtsVJxeiyfrVV_VxrAiIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/view/objective/index.vue")
  },
  {
    name: "admin_group_problem_solution_create",
    path: "solution/create",
    meta: indexQ5m2skjcvkdKXMk79MmHQLv5H6Llf3_bCKL971Wu_K8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/solution/create/index.vue")
  },
  {
    name: "admin_group_problem_create_objective",
    path: "create/objective",
    meta: indexmqvf2fSlgxxoH1ZGFjdLhWKBjhGiqni0470m7a_45tEmsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/problem/create/objective/index.vue")
  }
]
  },
  {
    name: "admin-group-training",
    path: "training",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training.vue"),
    children: [
  {
    name: "admin_group_training_edit",
    path: "edit",
    meta: indexOMdk6yxYVoK085DEsQKdztdHlXq_kfhHGV9NLsBW_45xcMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training/edit/index.vue")
  },
  {
    name: "admin_group_training_list",
    path: "list",
    meta: indexxyKUoU9ZgCtmkIbKnRSJ1_453fl0fF_o8NI4HcqKjUTq0Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training/list/index.vue")
  },
  {
    name: "admin_group_training_view",
    path: "view",
    meta: index_4cYLkFTkIhAdipCpz7vajNd_45VVqKbBA4DwZpd_45f0usMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training/view/index.vue")
  },
  {
    name: "admin_group_training_create",
    path: "create",
    meta: indexUclha9GO9aZDFzHZTPSWutHB689UfSc8_C_Xq_45WlUEAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training/create/index.vue")
  },
  {
    name: "admin_group_training_status",
    path: "status",
    meta: indexRxmy5L5evEsdtBdcjAoYzPL34Jq7WDFuV0YF_iaT5NoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training/status/index.vue")
  },
  {
    name: "admin_group_training_problem",
    path: "problem",
    meta: indexcBzCStj20AoLi_qVNoRqaVVrY4QxKnVLPNSWWHtwWS4Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/training/problem/index.vue")
  }
]
  },
  {
    name: "admin_group_edit",
    path: "edit",
    meta: indexzeZMmQRnv4Za6uZRJPnBPQN5P0XdygSrNglvGp2Twn8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/edit/index.vue")
  },
  {
    name: "admin_group_list",
    path: "list",
    meta: indexpzUy_LZ_aBZ68gA9qu_hP4FpeSzbJbk6pyMMQv_45BZFoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/list/index.vue")
  },
  {
    name: "admin_group_role",
    path: "role",
    meta: index4C8cyJbxGnXIkj7kkkJxk9IDu3w8ueU_C2rFBuXMgdcMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/role/index.vue")
  },
  {
    name: "admin_group_view",
    path: "view",
    meta: index9EZnySI7_45QhWaGyC_Rf7kye6RP2JaImD46i9xWadgHoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/view/index.vue")
  },
  {
    name: "admin_group_apply",
    path: "apply",
    meta: index7YMuRV_ht0WDGkUdmd8qTVc3qdvY6jEHb5MEL9tMPYwMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/apply/index.vue")
  },
  {
    name: "admin_group_create",
    path: "create",
    meta: indexD2kF1ygd4Fw3WA4gQsGI3_9AznuGN_b57eefdiV10M8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/create/index.vue")
  },
  {
    name: "admin_group_member",
    path: "member",
    meta: indexWOaejhbEYDFgjkUFH9shazDZV13hKNHJqg2vljeF2dMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/member/index.vue")
  },
  {
    name: "admin_group_announcement",
    path: "announcement",
    meta: indexXKIMfkMFZd2gBBXTr9Tc6y96EmsnHF2kC2NMvdcRSdMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/announcement/index.vue")
  },
  {
    name: "admin_group_announcement_create",
    path: "announcement/create",
    meta: index_VJ6DXxRN_h2s9_45_45Lw5oKyK45nQzVaWcjq6SUwYqREcMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/group/announcement/create/index.vue")
  }
]
  },
  {
    name: "admin",
    path: "/admin",
    meta: index_ZNJ9gVI5tgzdnwldStVmGcjoLX9Ozaw0iODRpQBOKAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/index.vue")
  },
  {
    name: "admin-contest",
    path: "/admin/contest",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest.vue"),
    children: [
  {
    name: "admin_contest_edit",
    path: "edit",
    meta: indexlj5IKoeLckZUpKSsKdXVdcCAQINzAyt6sthBxmY_ON0Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/edit/index.vue")
  },
  {
    name: "admin_contest_list",
    path: "list",
    meta: indexV6ycUgA0xZdtJUO_PwUCbK1pbmnkot7JwXs9f4W2eSYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/list/index.vue")
  },
  {
    name: "admin_contest_view",
    path: "view",
    meta: indexbeytsaBiKNp6PRSNgi2U0LIOmha4ljRer_PlEKdSYTYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/view/index.vue")
  },
  {
    name: "admin_contest_score",
    path: "score",
    meta: indexVptgxYqR_00dg6rqUd4BiASsLIp2z1aWVTw_457YG61CsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/score/index.vue")
  },
  {
    name: "admin_contest_create",
    path: "create",
    meta: indexP9UbNYiTWKkmF0H3ZZ_45psQQNs7EByHBd90FS_45hxBzrYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/create/index.vue")
  },
  {
    name: "admin_contest_problem",
    path: "problem",
    meta: indexIMb1WTsxqdtAAxoyaH1bMskP9oZWvZDT4F6aAX_45TsOsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/problem/index.vue")
  },
  {
    name: "admin_contest_submissions",
    path: "submissions",
    meta: index7TjAzaR_7CFclx85YUl7u8cNayaVQUAyD7_45z38hku2UMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/submissions/index.vue")
  },
  {
    name: "admin_contest_announcement",
    path: "announcement",
    meta: indexUPixVlElQPpUTSpR2y8yCWf8Cs_45YQpuV0Yy_45jbPJ9_450Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/announcement/index.vue")
  },
  {
    name: "admin_contest_announcement_create",
    path: "announcement/create",
    meta: index_45Ie_BLYeZ6FbuQGbddzZxcMeeZD2XzmkkwxTU1mFuQ0Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/contest/announcement/create/index.vue")
  }
]
  },
  {
    name: "admin-problem",
    path: "/admin/problem",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem.vue"),
    children: [
  {
    name: "admin_problem_list",
    path: "list",
    meta: indexck70JxAZffwdn6SNz5oXn9BTR6T2CaclIn0ahnQgC0QMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/list/index.vue")
  },
  {
    name: "admin_problem_edit_oj",
    path: "edit/oj",
    meta: indextPJeqC_atUwUZ41fMZPEUvGRbbNV47Kynh2EzQan7f8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/edit/oj/index.vue")
  },
  {
    name: "admin_problem_view_oj",
    path: "view/oj",
    meta: indexlsfNLuUJWzbgrpnZOHAql5XVXWr5jz6leZHHPytN1r4Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/view/oj/index.vue")
  },
  {
    name: "admin_problem_solution",
    path: "solution",
    meta: indexTpW008Ry_7uczmgFQkqdLmbtsc4NnaWci7n4VHEd6q8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/solution/index.vue")
  },
  {
    name: "admin_problem_create_oj",
    path: "create/oj",
    meta: indexTKVNQ69C_9uhHgxfkoLNYo4u_e3eM3zhzfT2hmi4Vo0Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/create/oj/index.vue")
  },
  {
    name: "admin_problem_edit_objective",
    path: "edit/objective",
    meta: indexLqkJbNRLyzr146gvLOpA8aNa6S_45gE3Ftkk4GrsdPRCAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/edit/objective/index.vue")
  },
  {
    name: "admin_problem_view_objective",
    path: "view/objective",
    meta: indexQLoyjWUuvPQog4ug9fUqtOGwrrBN9rw1wPubG9TdoC4Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/view/objective/index.vue")
  },
  {
    name: "admin_problem_solution_create",
    path: "solution/create",
    meta: index_45OBQJkYSHVs05lGGz_45uFiZNPz6yERrBaaeB46sRalsQMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/solution/create/index.vue")
  },
  {
    name: "admin_problem_create_objective",
    path: "create/objective",
    meta: indexF1GPSHVWh2sM97no_Pe9Xb680RNXxfhFJUNeH6qQbe0Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/problem/create/objective/index.vue")
  }
]
  },
  {
    name: "oj_task",
    path: "/oj/task",
    meta: indexC4A0WcPD9AAsSHzy5LkQNpen0vhe_yL7zSDDNh7KgnEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/task/index.vue")
  },
  {
    name: "admin-training",
    path: "/admin/training",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training.vue"),
    children: [
  {
    name: "admin_training_edit",
    path: "edit",
    meta: indexJSWBhdlLlpdBK4Ve1tbT88wYGnoA_45OIT61o45y8ZoiUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training/edit/index.vue")
  },
  {
    name: "admin_training_list",
    path: "list",
    meta: indexBxFFULHs5zgAs5_45qcc6s_45aVGNH0kQHPRJqTDvuToiHYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training/list/index.vue")
  },
  {
    name: "admin_training_view",
    path: "view",
    meta: indexCebpB3YZ6lOebrzVnorG89HHitKlzvIgDjsAyvAOFxMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training/view/index.vue")
  },
  {
    name: "admin_training_create",
    path: "create",
    meta: indexMdilp8FjTErLUPE75IWjQg_c2u1wupZEWgGQdrjRPhsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training/create/index.vue")
  },
  {
    name: "admin_training_status",
    path: "status",
    meta: indexwnopxNnM8HyL_gcTg8PWTsTT2tkUsj4uUZe4SBEkO6kMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training/status/index.vue")
  },
  {
    name: "admin_training_problem",
    path: "problem",
    meta: indexsApNAJJgcyXrmWwJOAvdYGm43SqyIhCoE89YYNobXHIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/training/problem/index.vue")
  }
]
  },
  {
    name: "oj_guide",
    path: "/oj/guide",
    meta: index9Rk_45YSL_nTFFZ4MY0S_45103RhZaoOOWits0wg8IZoXS8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/guide/index.vue")
  },
  {
    name: "admin-community",
    path: "/admin/community",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/community.vue"),
    children: [
  {
    name: "admin_community_post",
    path: "post",
    meta: indexRYbWD5EmnnlxKelqJ_452upOiZsTytDk4Q6EGtq3pmuSQMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/community/post/index.vue")
  },
  {
    name: "admin_community_solution",
    path: "solution",
    meta: index9wEfQAx49jyJPU7P2QZfZdy8Mqyoi0QJ_xv_456dJLdsIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/community/solution/index.vue")
  },
  {
    name: "admin_community_post_comment",
    path: "post/comment",
    meta: indexrhOav_45xTpN5a042HxraE4f0Arn7STlC6bzgve7EC76IMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/community/post/comment/index.vue")
  },
  {
    name: "admin_community_problem_comment",
    path: "problem/comment",
    meta: indexxia4GDYL9FmwOEFuFSy0nVNQmpkLTQp_7__45dGAjox68Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/community/problem/comment/index.vue")
  },
  {
    name: "admin_community_solution_comment",
    path: "solution/comment",
    meta: index9EutJxo_454d9qD09uZ3QSBo8dFqnfiAEaNeXo9Bvlp8sMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/community/solution/comment/index.vue")
  }
]
  },
  {
    name: "admin-warehouse",
    path: "/admin/warehouse",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse.vue"),
    children: [
  {
    name: "admin_warehouse_edit",
    path: "edit",
    meta: indexFVxUUAqiRvNGTqdBoHu8vqgWt8zr5cPV8H7VSutlvKsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse/edit/index.vue")
  },
  {
    name: "admin_warehouse_list",
    path: "list",
    meta: indexYcvZw1TIvEh0WebHDvXzbMCgma_10z_45f8dCsIrfWHmAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse/list/index.vue")
  },
  {
    name: "admin_warehouse_view",
    path: "view",
    meta: indexIirtLAEgd_45d_7UjOtHXv4dz6JEAUnVqxvMYFLdopO7wMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse/view/index.vue")
  },
  {
    name: "admin_warehouse_create",
    path: "create",
    meta: indexuLTVW7AdzZS_hV8v7kbTdNo3glX88GdwymnzNP8i0CsMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse/create/index.vue")
  },
  {
    name: "admin_warehouse_import",
    path: "import",
    meta: index3zlb4IQcjZQ48N2vJ6H441mn0wIiK7x214okF_45zILzYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse/import/index.vue")
  },
  {
    name: "admin_warehouse_problem",
    path: "problem",
    meta: indexCFzhxeLK6KSX1TxNwOQ_45Cpi_45gCT1ZeVOBC2Ajg96eREMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/warehouse/problem/index.vue")
  }
]
  },
  {
    name: "oj_notice",
    path: "/oj/notice",
    meta: indexuWw4_45yJR0tDi02qEU32SV6nj_45_uE6Z_HYneEZJMXWPwMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/notice/index.vue")
  },
  {
    name: "admin_user",
    path: "/admin/user",
    meta: index0_45iRiitlygsCobDrn0KBlwkQPBlSeHE0Rmts_45ffSQCUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/user/index.vue")
  },
  {
    name: "discuss-category",
    path: "/discuss/category",
    meta: category9tTnrmVEqMW244AVWtQLRpAy01enELHIMEdDyUyTL_0Meta || {},
    redirect: {"name":"discuss_category_academic"},
    component: () => import("/work/release/fe-oj-ninja/pages/discuss/category.vue"),
    children: [
  {
    name: "discuss_category_general",
    path: "general",
    meta: indexsRbXHGvMMIqu_93iANyiVo4QZxquSlK0N5KaEJEupA8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/discuss/category/general/index.vue")
  },
  {
    name: "discuss_category_academic",
    path: "academic",
    meta: indexLjg3IGRcT79v5_45jkFjnBoSPElX3W8jlFflPu0ZWUF1wMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/discuss/category/academic/index.vue")
  }
]
  },
  {
    name: "oj_article",
    path: "/oj/article",
    meta: indexhfMHKxOUzOvUnG90gUyM7awPLTh0oVt6YoK8qYeuHhAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/article/index.vue")
  },
  {
    name: "oj_contest",
    path: "/oj/contest",
    meta: indexc7G6DZlx422nqsWIeS5n5M_45Q6BIJPWhAiAG7rBfyUzkMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/contest/index.vue")
  },
  {
    name: "oj_problem",
    path: "/oj/problem",
    meta: index65pVChW0Hq9W7Vt3dbsNVzkRwGv0WS58Cnugzt2ypNkMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/index.vue")
  },
  {
    name: "oj_ranking",
    path: "/oj/ranking",
    meta: indexwgu9nGRRVoRwx3UF35faUFee7uWX5GAATqGuUXqer_wMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/ranking/index.vue")
  },
  {
    name: "admin-indexconfig",
    path: "/admin/indexconfig",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/indexconfig.vue"),
    children: [
  {
    name: "admin_indexconfig_banner",
    path: "banner",
    meta: indexwxIMIWye8WFBsgLz8LKvKUL0ws0PCj554UwlzvX0_SAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/indexconfig/banner/index.vue")
  },
  {
    name: "admin_indexconfig_article",
    path: "article",
    meta: indexhyVu4Sho7yzIBlHSoXmFukHf1Ts3yi9lIBieSlvL8s4Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/indexconfig/article/index.vue")
  },
  {
    name: "admin_indexconfig_contest",
    path: "contest",
    meta: indexsvn__zzfA4_jUlY_45K1jUiLpXw3WkuGXDGaYMWzYJSNEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/indexconfig/contest/index.vue")
  },
  {
    name: "admin_indexconfig_banner_create",
    path: "banner/create",
    meta: index7R1NPBSzKXGyAW26TJlFkf8_45grsVfPnhVUP5bWcdcvoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/indexconfig/banner/create/index.vue")
  },
  {
    name: "admin_indexconfig_article_create",
    path: "article/create",
    meta: indexLELOlpi2UCGUuXMpru6HS8DuFBtbiSTNLdGY4eyQzdUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/indexconfig/article/create/index.vue")
  }
]
  },
  {
    name: "oj_backpack",
    path: "/oj/backpack",
    meta: indexCTMrcfwN__nBZjNU3e_45di76aIjAXUWQJSJfI1STl6JUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/backpack/index.vue")
  },
  {
    name: detailoyYV5blsf7EuTDdggDj3BkKKFCDTXEIVntks9pxBdW0Meta?.name,
    path: "/oj/contest/detail",
    component: () => import("/work/release/fe-oj-ninja/pages/oj/contest/detail.vue"),
    children: [
  {
    name: "oj_contest_detail",
    path: "",
    meta: indexP5ZuqQX8W9J6RdJnWeVbREa0JF2rVNhn0btKTv4ZzdIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/contest/detail/index.vue")
  },
  {
    name: "oj_contest_detail_score",
    path: "score",
    meta: indexZ09mMIt0A6pU1DGQnKsEU01OZFayNTl5BX2WZqs_YQQMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/contest/detail/score/index.vue")
  },
  {
    name: "oj_contest_detail_notice",
    path: "notice",
    meta: indexrtSZFHbvN0_YJ1532qcE5lRmggdlZVIiqXC5oJs6GUUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/contest/detail/notice/index.vue")
  },
  {
    name: "oj_contest_detail_problem",
    path: "problem",
    meta: index6x3SETeFtL_45NIvhekpRZsJgq3EB3BvB93FRZyvBC5FIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/contest/detail/problem/index.vue")
  }
]
  },
  {
    name: "oj_training",
    path: "/oj/training",
    meta: indexrDqm0ICd2eOy_6qvSRcfcxYrk5qKilHusgpGue5ha_wMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/training/index.vue")
  },
  {
    name: detailzZNsKg2khTBhOJ453A6Hu88vwC0RILTvFYhWnAvtTpcMeta?.name,
    path: "/oj/training/detail",
    component: () => import("/work/release/fe-oj-ninja/pages/oj/training/detail.vue"),
    children: [
  {
    name: "oj_training_detail",
    path: "",
    meta: indexBjtG_45Mjk1UgLnyUQ6sL195B8Y502uC_45NdAkzBpo9MmAMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/training/detail/index.vue")
  },
  {
    name: "oj_training_detail_problem",
    path: "problem",
    meta: indexe_45t_45KZ1_rRP6F74aCkbtxVjF3sRHsbU4lpJquVAdg6oMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/training/detail/problem/index.vue")
  }
]
  },
  {
    name: "callback_code",
    path: "/callback/code",
    meta: indexiRgkGHvaqE6UbP8uRQjvZBE0oOQOD0ZrJggx4BzDHFoMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/callback/code/index.vue")
  },
  {
    name: "callback_group",
    path: "/callback/group",
    meta: indexcQcOFcS8H1VDvta6FJ07F8fpcVwsP_45DtKKxeivp0LcYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/callback/group/index.vue")
  },
  {
    name: "callback_feishu",
    path: "/callback/feishu",
    meta: indexAnm0mIIbPZSE3k_45ljXlQ76UIttU17EHnEk0cBS2RyCUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/callback/feishu/index.vue")
  },
  {
    name: "callback_wechat",
    path: "/callback/wechat",
    meta: index1GyQhMB5bSTyX5IePtGT9BFjRcY5ULPu0l7MPCXMtHgMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/callback/wechat/index.vue")
  },
  {
    name: "oj_announcement_detail",
    path: "/oj/announcement",
    meta: indexa8Lawgz1WiRtGlfjKcXZ_yeW74D6EEgjRf3xGlI5FscMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/announcement/index.vue")
  },
  {
    name: "admin-incentive-reward",
    path: "/admin/incentive/reward",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/reward.vue"),
    children: [
  {
    name: "admin_incentive_reward_badge",
    path: "badge",
    meta: indexXQa0EAT7x6aUfa8tSM0DNwVs1XZ6PJ6lwldJXVTaldEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/reward/badge/index.vue")
  },
  {
    name: "admin_incentive_reward_avatarframe",
    path: "avatarframe",
    meta: indexylVO5zT53X_AHUFG_tvoZTiD2Mt20g1VJTbu0GqWGZ8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/reward/avatarframe/index.vue")
  },
  {
    name: "admin_incentive_reward_cursortrails",
    path: "cursortrails",
    meta: indexobCwL1uMyAGIrrHUwcTVXmdmA6Smm6nKAP9mCRw5L_45oMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/reward/cursortrails/index.vue")
  },
  {
    name: "admin_incentive_reward_homebackground",
    path: "homebackground",
    meta: indextPy2wuMePFePUIv3vVcd3WCkabamNdDCPRmxMHD4QvEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/reward/homebackground/index.vue")
  },
  {
    name: "admin_incentive_reward_gradedecoration",
    path: "gradedecoration",
    meta: indexIz5iDvoe3W6Nt3DHCnedjfkyV9e62Fjcez8y8Gx1sB8Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/reward/gradedecoration/index.vue")
  }
]
  },
  {
    name: "admin_submission",
    path: "/admin/submission",
    meta: index_45Ea_45lE9ly3Fg7wt9PORvb35O4_45mt1dd13fJQuhW695gMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/submission/index.vue")
  },
  {
    name: "oj_entrance_exam",
    path: "/oj/entrance-exam",
    meta: indexJ8hdhXjxnVD_Q5c64R86KDMmakG6LQmdHZf4lZNQfUEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/entrance-exam/index.vue")
  },
  {
    name: "admin-incentive-mission",
    path: "/admin/incentive/mission",
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission.vue"),
    children: [
  {
    name: "admin_incentive_mission_edit",
    path: "edit",
    meta: indexCz_oU3kI0RmsLqPQ3df0qfstZqgH_bTyWqzBz5V7OKIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/edit/index.vue")
  },
  {
    name: "admin_incentive_mission_view",
    path: "view",
    meta: indexoGDmQxHNA0bI_45VaZh2ZasH0P5sfp3FuBCqAo2QMum98Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/view/index.vue")
  },
  {
    name: "admin_incentive_mission_goods",
    path: "goods",
    meta: indexkQcCN6Cef0de7kgbi_5BQZa9ZLBCTvcKS6m3FyRsQ60Meta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/goods/index.vue")
  },
  {
    name: "admin_incentive_mission_medal",
    path: "medal",
    meta: indexyzTNbgmhKFzVRPkORP6QEC_2yx77j_N3_45svYItNY4qEMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/medal/index.vue")
  },
  {
    name: "admin_incentive_mission_create",
    path: "create",
    meta: index8evFifEQ3jPqnQCbV6XKp_45RA9cE23A_X_1w8dvXE3RMMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/create/index.vue")
  },
  {
    name: "admin_incentive_mission_manual",
    path: "manual",
    meta: indexbzVgWvv0epktwCiPM_459ACTNikmS21D4kIBDcRWIob5oMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/manual/index.vue")
  },
  {
    name: "admin_incentive_mission_normal",
    path: "normal",
    meta: index0kmiqxKIehNipOKlEJFO9wnNjkc2nVmUGnBKANsBdEUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/normal/index.vue")
  },
  {
    name: "admin_incentive_mission_random",
    path: "random",
    meta: indexj_450ZXRatbEq66jp42ku3O_45_KcyJuuTnc9NRYJsBtNaIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/mission/random/index.vue")
  }
]
  },
  {
    name: "discuss_post_edit",
    path: "/discuss/post/edit",
    meta: index6gapf0ZAc170u12BSZn8YBBDl9mM7tmhrqQ3cy7VVzwMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/discuss/post/edit/index.vue")
  },
  {
    name: "oj_article_detail",
    path: "/oj/article/detail",
    meta: indexB4U6RyuG6nmU13ae5kX3x1vrBCHYWwWjwG1aRKGgHMIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/article/detail/index.vue")
  },
  {
    name: "oj_problem_detail",
    path: "/oj/problem/detail",
    meta: indexLgPhsEIw3po5AlcN5injinQs9flpCWNc7SJrqDujMskMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/detail/index.vue")
  },
  {
    name: "admin_clouddesktop",
    path: "/admin/clouddesktop",
    meta: indexwwPpniRCEb_BuWEHNJlzM1SiV9xNkuSMx8_45_45WZ8XcckMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/clouddesktop/index.vue")
  },
  {
    name: "oj_activity_zongzi",
    path: "/oj/activity/zongzi",
    meta: indextHKzLN1VmJLQi1WTQdYIV7n_45xMRd0_45Wf41FlAbX__45kUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/activity/zongzi/index.vue")
  },
  {
    name: "discuss_post_create",
    path: "/discuss/post/create",
    meta: index8V9WGVHj90r_450kGHH9uqz7s2_451PleoyxwqtE6dT2a_MMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/discuss/post/create/index.vue")
  },
  {
    name: "discuss_post_detail",
    path: "/discuss/post/detail",
    meta: indexOODfGCB3YIOVDu7OJrRvMZ0sfrx1RgREHzBx3GPf4OcMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/discuss/post/detail/index.vue")
  },
  {
    name: "oj_activity_lantern",
    path: "/oj/activity/lantern",
    meta: indexudKOeRMY2IcZ9VVKLOPBzGsDKC9r2328UL34IAgYC_45gMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/activity/lantern/index.vue")
  },
  {
    name: "oj_problem_solution",
    path: "/oj/problem/solution",
    meta: indexTg8l20YCXo1uJaCJ86LFqSPv1TMKL4qs0fVWZX9CnWUMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/solution/index.vue")
  },
  {
    name: "admin_incentive_level",
    path: "/admin/incentive/level",
    meta: indexlb85F_45rGqLPseTzc0ITFlcxqcUgDheJgDEIKp7JN8gwMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/admin/incentive/level/index.vue")
  },
  {
    name: "oj_problem_submit_list",
    path: "/oj/problem/submit/list",
    meta: indexQ0Orz4xDAh90x7RoSlB28uy_45yGAM_TTHdiAWiP173vgMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/submit/list/index.vue")
  },
  {
    name: "oj_problem_solution_edit",
    path: "/oj/problem/solution/edit",
    meta: index071s0gZ0k0TC_4564HDaJLYlMggCI_KOQXuOG_7FFjTpIMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/solution/edit/index.vue")
  },
  {
    name: "oj_problem_submit_result",
    path: "/oj/problem/submit/result",
    meta: index2eKtw7iU5_45LTd6l9K3VwF7wHlRsjQabYC75Js6My68kMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/submit/result/index.vue")
  },
  {
    name: "oj_problem_solution_create",
    path: "/oj/problem/solution/create",
    meta: indexA5j7BkP0eAo_45HcmZPiHoxNM3qv7stduw6wLlO8xxMPYMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/solution/create/index.vue")
  },
  {
    name: "oj_problem_solution_detail",
    path: "/oj/problem/solution/detail",
    meta: indexrSqjS1jbtBXFEIMFW5XiivWBfYFCtjkrwKslEQUOvREMeta || {},
    component: () => import("/work/release/fe-oj-ninja/pages/oj/problem/solution/detail/index.vue")
  },
  {
    name: component_45stubDMgF2QhSnKdc6GIkjVfhMgbG5hzZAWM_45yH1BKqK2dlUMeta?.name,
    path: "/oj",
    component: component_45stubDMgF2QhSnKdc6GIkjVfhMgbG5hzZAWM_45yH1BKqK2dlU
  },
  {
    name: component_45stubDMgF2QhSnKdc6GIkjVfhMgbG5hzZAWM_45yH1BKqK2dlUMeta?.name,
    path: "/discuss",
    component: component_45stubDMgF2QhSnKdc6GIkjVfhMgbG5hzZAWM_45yH1BKqK2dlU
  }
]